import { defineStore } from 'pinia';

import type { Severity, GlobalMessage } from '../types';
import { SeverityEnum } from '../types';

interface MessageStackI {
	read: Array<GlobalMessage>;
	unread: Array<GlobalMessage>;
	onDisplay: GlobalMessage | null;
	intervalId?: ReturnType<typeof setInterval>;
}
export interface GlobalMessageStateI {
	[SeverityEnum.UNClASSIFIED]: MessageStackI;
	[SeverityEnum.INFORMATION]: MessageStackI;
	[SeverityEnum.WARNING]: MessageStackI;
	[SeverityEnum.ERROR]: MessageStackI;
}

const state: GlobalMessageStateI = {
	[SeverityEnum.UNClASSIFIED]: {
		unread: [],
		read: [],
		onDisplay: null,
		intervalId: undefined,
	},
	[SeverityEnum.INFORMATION]: {
		unread: [],
		read: [],
		onDisplay: null,
		intervalId: undefined,
	},
	[SeverityEnum.WARNING]: {
		unread: [],
		read: [],
		onDisplay: null,
		intervalId: undefined,
	},
	[SeverityEnum.ERROR]: {
		unread: [],
		read: [],
		onDisplay: null,
		intervalId: undefined,
	},
};

export const useGlobalMessageStore = defineStore('globalMessages', {
	state: () => state,
	actions: {
		addMessage(message: GlobalMessage) {
			this[message.severity].unread.push(message);
			this[message.severity].intervalId = setInterval(this.readAll, 250, message.severity);
		},
		readAll(severity: Severity) {
			if (this[severity].unread.length) {
				if (!this[severity].onDisplay) this.readOldestMessage(severity);
			} else if (this[severity].intervalId) {
				clearInterval(this[severity].intervalId);
				this[severity].intervalId = undefined;
			}
		},
		// maybe this function should not be exposed
		markMessageAsRead(severity: Severity, index: number) {
			if (this[severity].unread.length && index >= 0 && index < this[severity].unread.length) {
				const [message] = this[severity].unread.splice(index);
				this[severity].read.push(message);
			}
		},
		readOldestMessage(severity: Severity) {
			const unreadMessages = this[severity].unread;
			if (unreadMessages.length === 0) return null;

			const oldestMessage = unreadMessages[0];
			const equalMessageIndexes: Array<number> = unreadMessages.reduce((aggregate: Array<number>, message, index) => {
				if (message.isEqual(oldestMessage)) aggregate.push(index);
				return aggregate;
			}, []);

			for (const equalMessageIndex of equalMessageIndexes) this.markMessageAsRead(severity, equalMessageIndex);

			this[severity].onDisplay = oldestMessage;
		},
	},
});
